import { getCommonMessage } from './commonReplyGetters';
import { getFilteredRecipientsByField } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
export const replyHasRecipient = reply => {
  const commonMessage = getCommonMessage(reply);
  const toRecipients = getFilteredRecipientsByField(commonMessage, 'TO');
  return Boolean(toRecipients && toRecipients.size);
};